<div class="risk-excel-upload">
	<p-toast position="top-right"></p-toast>

	<!-- Hero card: modo "ya cargado" → solo info + descarga -->
	<section class="section-header" *ngIf="hasImportedData; else uploadHero">
		<div class="header-content">
			<div class="header-left">
				<i class="fa-solid fa-file-excel"></i>
				<div class="header-text">
					<h1>Análisis de Riesgo importado</h1>
					<p class="header-subtitle" *ngIf="importedAt">
						Importado el {{ importedAt | date:'longDate' }}
						<span *ngIf="excelFileName"> · <strong>{{ excelFileName }}</strong></span>
					</p>
					<p class="header-subtitle" *ngIf="!importedAt">
						Datos parseados del Excel — solo lectura desde aquí.
					</p>
				</div>
			</div>
			<div class="header-right">
				<p-tag value="Cargado" severity="success" icon="pi pi-check-circle"></p-tag>
				<p-button
					[label]="isDownloading ? 'Descargando…' : 'Descargar Excel'"
					[icon]="isDownloading ? 'pi pi-spin pi-spinner' : 'pi pi-download'"
					severity="success"
					[outlined]="true"
					[disabled]="!excelFileUrl || isDownloading"
					(click)="downloadExcel()">
				</p-button>
				<!-- Solo Admin y Finanzas pueden reemplazar el Excel (permiso risk.re-upload). -->
				<p-button
					*appIfHasPermission="['risk','re-upload']"
					[label]="isReuploading ? 'Reemplazando…' : 'Reemplazar Excel'"
					[icon]="isReuploading ? 'pi pi-spin pi-spinner' : 'pi pi-refresh'"
					severity="warning"
					[outlined]="true"
					[disabled]="isReuploading"
					(click)="confirmReupload()">
				</p-button>
				<input #reuploadInput type="file" accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" hidden (change)="onReuploadFileSelected($event)" />
			</div>
		</div>
	</section>
	<p-confirmDialog [style]="{width: '480px'}" acceptButtonStyleClass="p-button-warning" rejectButtonStyleClass="p-button-text"></p-confirmDialog>

	<!-- Hero card: modo "sin datos" → warning + uploader -->
	<ng-template #uploadHero>
		<section class="section-header">
			<div class="header-content">
				<div class="header-left">
					<i class="fa-solid fa-file-excel"></i>
					<div class="header-text">
						<h1>Importar Análisis de Riesgo desde Excel</h1>
						<p class="header-subtitle">
							Sube el archivo <strong>"Análisis de Riesgos - Rendafin v1"</strong> que llenó Finanzas/Riesgos.
						</p>
					</div>
				</div>
				<div class="header-right">
					<p-tag value="Pendiente" severity="secondary"></p-tag>
				</div>
			</div>
		</section>

		<section class="info-card upload-body">
			<div class="card-content">
				<div class="upload-warning">
					<i class="fa-solid fa-triangle-exclamation"></i>
					<div>
						<strong>Importante:</strong> una vez cargado el Excel, los datos
						<strong>ya NO podrán ser modificados</strong> desde la plataforma.
						Quedará disponible un botón para descargar el archivo original.
					</div>
				</div>

				<div class="upload-meta">
					<span><i class="fa-solid fa-circle-info"></i> Solo archivos <code>.xlsx</code></span>
					<span class="dot">·</span>
					<span>Tamaño máximo 10 MB</span>
				</div>

				<!-- Solo roles con risk.create pueden cargar el Excel inicial (POST /risk/import-excel).
				     Legal es read-only de riesgo (risk.view) → ve el estado "sin datos" sin uploader. -->
				<div class="upload-action" *appIfHasPermission="['risk','create']">
					<p-fileUpload
						name="file"
						accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
						[maxFileSize]="10485760"
						[customUpload]="true"
						[auto]="true"
						[showUploadButton]="false"
						[showCancelButton]="false"
						chooseLabel="Seleccionar Excel"
						chooseIcon="pi pi-upload"
						chooseStyleClass="p-button p-button-success"
						(uploadHandler)="onUpload($event)"
						mode="basic">
					</p-fileUpload>

					<div *ngIf="isUploading" class="upload-status">
						<i class="fa-solid fa-spinner fa-spin"></i>
						Procesando <strong>{{ selectedFileName }}</strong>...
					</div>
				</div>
			</div>
		</section>
	</ng-template>
</div>
